import React, { useEffect, useState } from "react";
import { Autocomplete, Box, TextField } from "@mui/material";
import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  height: 100%;

  .MuiAutocomplete-root {
    input.MuiAutocomplete-input {
      font-weight: 100;
      color: var(--Text-Primary) !important;
      font-family: "AllianceNo2-SemiBold" !important;
    }

    .MuiAutocomplete-inputRoot:before {
      border-bottom-color: #ddd !important;
      border-bottom: 1px solid var(--title-color) !important; 
    }
  }

  .MuiAutocomplete-popper {
    ul li {
      font-family: AllianceNo2-SemiBold;
      font-weight: 100;
      color: var(--Text-Primary) !important;
      font-weight: 400;
    }
  }

  .MuiAutocomplete-endAdornment button {
    color: var(--Text-Primary) !important;
    &:hover {
      background: transparent;
    }
  }
`;

const IconContainer = styled.div`
  font-family: AllianceNo2-SemiBold;
  font-weight: 100;
  padding-right: 10px;

  i {
    font-size: 18px;
    color: var(--Text-Primary);
  }
`;

const OptionIconContainer = styled.div`
  display: flex;
  align-items: center;
  margin: -6px 3px 0px -13px;

  i.option-icon {
    font-size: 12px;
    color: var(--Text-Primary);
  }
`;

const OptionLabel =styled.div`
  white-space: nowrap;
  line-height: 14px;
  width: 100%;
  text-overflow: ellipsis;
  font-size: 12px;
  overflow: hidden;
`;

const doesNothing = () => {};

const findOptionOrPassValue = (value, options) =>
  typeof value === 'object' ? value :
    options.find(option => option.value === value) || value;

const SelectAutocomplete = ({
  className = "",
  icon = null,
  name = "",
  title = "",
  selected = null,
  options = [],
  onChange = doesNothing,
  inForm = false,
  disableClearable = false,
  getOptionDisabled = () => false,
  isOptionEqualToValue,
  onOpen = doesNothing,
}) => {
  const [value, setValue] = useState(selected || options[0]);

  useEffect(() => {
    if(selected === null || selected === undefined){
      return;
    }

    setValue(selected);
  }, [selected])

  return (
    <Wrapper className={`${className}`}>
      {icon ? (
        <IconContainer title={title || name}>
          <i className="material-icons">{icon}</i>
        </IconContainer>
      ) : null}
      <Autocomplete
        onOpen={onOpen}
        name={name}
        value={findOptionOrPassValue(value, options)}
        onChange={(event, newValue) => {
          if (newValue !== null) {
            setValue(newValue);
            onChange(newValue.value);
          }
        }}
        disablePortal
        options={options}
        sx={{ width: "100%",  fontFamily: "AllianceNo2-SemiBold !important", }}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="standard"
            sx={{ width: "100%", fontSize: "12px", fontWeight: 400,  fontFamily: "AllianceNo2-SemiBold !important", }}
          />
        )}
        disableClearable={disableClearable}
        getOptionDisabled={getOptionDisabled}
        isOptionEqualToValue={isOptionEqualToValue}
        renderOption={(props, option) => (
          <Box component="li" sx={{ display: "flex", alignItems: "center" }} {...props}>
            {option.icon && (
              <OptionIconContainer>
                <i className="option-icon material-icons">{option.icon}</i>
              </OptionIconContainer>
            )}
            <OptionLabel title={option.label}>{option.label}</OptionLabel>
          </Box>
        )}
      />
      { inForm !== true ? null :
        <input type="hidden" name={name} value={value.value} />
      }
    </Wrapper>
  );
};

export default SelectAutocomplete;
